import React, { ReactNode } from 'react';

import {
  ResourceDetailVoteContainer,
  ResourceDetailVoteIconContainer,
  ResourceDetailVoteText,
  ResourceDetailVoteWrapper,
} from 'app/components/Resources/ResourceDetail/ResourceDetailVote/styled';
import KyuLaurelBadgeIcon from 'app/components/shared/icons/kyu-laurel-badge';
import styled, { ThemeProvider } from 'styled-components';

const Banner = styled(ResourceDetailVoteWrapper)`
  && {
    min-height: 0;
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
    padding: 20px;
  }
`;

const Category = styled(ResourceDetailVoteContainer)`
  && {
    width: 100%;
    flex-direction: row;
    gap: 12px;
  }

  ${ResourceDetailVoteIconContainer} {
    flex-shrink: 0;
  }

  ${ResourceDetailVoteText} {
    text-align: left;
    overflow-wrap: anywhere;
  }
`;

const Copy = styled.div`
  display: grid;
  gap: 4px;
  min-width: 0;
`;

const ErrorText = styled.span`
  color: #8a2b2b;
  font-size: 12px;
  line-height: 1.35;
`;

export default function BestOfSubmissionCategoryBanner({
  categoryName,
  neutral = false,
  error,
  children,
}: {
  categoryName: string;
  neutral?: boolean;
  error?: string | null;
  children?: ReactNode;
}) {
  return (
    <ThemeProvider theme={{ isVoted: false }}>
      <Banner aria-label="Submission category">
        <Category>
          <ResourceDetailVoteIconContainer aria-hidden="true">
            <KyuLaurelBadgeIcon width={40} height={27} />
          </ResourceDetailVoteIconContainer>
          <Copy>
            <ResourceDetailVoteText>
              {neutral ? 'Entry in' : 'Your entry in'} {categoryName}
            </ResourceDetailVoteText>
            {error ? <ErrorText role="alert">{error}</ErrorText> : null}
          </Copy>
        </Category>
        {children}
      </Banner>
    </ThemeProvider>
  );
}
